'use client';
import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { CatSideMenu, CatSideMenuItem } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useGaEventContext } from '../../gaevent-context-provider';
import { SidePanelProps } from '../../types';
import styles from '../../customer-account.module.scss';

export const SidePanel = ({
  sideMenuList,
  equipment,
  serviceInsight,
  recentlyViewed,
  buyAgain
}: Readonly<SidePanelProps>) => {
  const t = useTranslations();
  const [menuItem, setMenuItem] = useState(sideMenuList.myEquipment.name);
  const { handleGaEventCapture } = useGaEventContext();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);

  const onSideMenuChange = (value: string) => {
    setMenuItem(value);
    handleGaEventCapture(value, true);
  };

  useEffect(() => {
    if (isLG === false) {
      handleGaEventCapture(null, true);
    }
  }, [isLG, handleGaEventCapture]);

  const getSidePanelContent = (currentMenuItem: string) => {
    switch (currentMenuItem) {
      case sideMenuList.myEquipment.name:
        return equipment;
      case sideMenuList.serviceRecommendation.name:
        return serviceInsight;
      case sideMenuList.recentlyViewed.name:
        return recentlyViewed;
      case sideMenuList.buyAgain.name:
        return buyAgain;
      default:
        return sideMenuList.myEquipment.name;
    }
  };

  return (
    <>
      <div
        className={`${styles['customer-account-wrapper--tabs-wrapper']} d-none d-blg-block`}
      >
        <CatSideMenu
          className={`${styles['customer-account__side-menu--no-border']}`}
        >
          {Object.values(sideMenuList).map((menu) => {
            if (!menu?.isHide) {
              return (
                <CatSideMenuItem
                  className={`${styles['customer-account__side-menu--list']}`}
                  key={menu.name}
                  isCurrent={menuItem === menu.name}
                  onClick={() => onSideMenuChange(menu.name)}
                  data-track-event={menu.ga_event_name}
                  data-track-attr-nltext={menu.ga_nltext}
                  data-track-attr-context={menu.ga_context}
                >
                  <Conditional
                    test={!!menu.icon}
                    fallback={<div className="mx-4">{t(menu.label)}</div>}
                  >
                    <div className="d-flex">
                      <div
                        className={`${styles['customer-account__side-menu--icon']} mx-2`}
                      >
                        {menu.icon}
                      </div>
                      {t(menu.label)}
                    </div>
                  </Conditional>
                </CatSideMenuItem>
              );
            }
          })}
        </CatSideMenu>
      </div>

      <div
        className={`position-relative ${styles['customer-account--content-wrapper']}  d-none d-blg-block`}
      >
        {getSidePanelContent(menuItem)}
      </div>

      <div className="d-blg-none">
        {equipment}
        {serviceInsight}
        {recentlyViewed}
        {buyAgain}
      </div>
    </>
  );
};
